import React, { useState } from "react";
import ConfirmPasswordModal from "./ConfirmPasswordModal";

const UserTable = ({ users, editUser, deleteUser }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // ✅ Open ConfirmPasswordModal when delete is triggered
  const handleDelete = (userId) => {
    setSelectedUser(userId);
    setShowConfirmModal(true);
  };

  // ✅ Execute delete after confirmation
  const confirmDelete = async () => {
    if (selectedUser) {
      await deleteUser(selectedUser);
      setSelectedUser(null);
      setShowConfirmModal(false);
    }
  };

  return (
    <div className="browse_client_table_body">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Created</th>
            <th>Manage</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user) => (
              <tr key={user.user_id}>
                <td>{user.user_name}</td>
                <td>{user.user_email}</td>
                <td>
                  {user.user_created
                    ? new Date(user.user_created).toISOString().split("T")[0].replace(/-/g, "/")
                    : "N/A"}
                </td>
                <td>
                  <div className="share_dtls_btn_holder">
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => editUser(user.user_id)}
                    >
                      <span><i className="fa-solid fa-user-pen"></i></span>
                    </button>
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => handleDelete(user.user_id)} // ✅ Trigger delete confirmation
                    >
                      <span><i className="fa-solid fa-user-minus"></i></span>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ✅ Confirm Password Modal */}
      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSuccess={confirmDelete}
      />
    </div>
  );
};

export default UserTable;
